export const TopicState = Object.freeze({
  DELETED: -1,
  INVISIBLE: 0,
  VISIBLE: 1,
});

export const TopicStateOptions = Object.freeze([
  {
    value: TopicState.VISIBLE,
    label: "표시",
  },
  {
    value: TopicState.INVISIBLE,
    label: "숨김",
  },
  {
    value: TopicState.DELETED,
    label: "삭제",
  },
]);
